import React from "react";
import InputGroup7 from "./InputGroup7";
import { FaSearch } from 'react-icons/fa';

const GlobalSearchFilter = ({ globalFilter, setGlobalFilter, className = "" }) => {
    return (
        <InputGroup7
            name="search"
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            label="Buscar"
            decoration={<FaSearch size="1rem" className="text-gray-400" />}
            className={className}
        />
    );
};

export default GlobalSearchFilter;
